import { render } from "./HistoryApprovalMappingList.vue?vue&type=template&id=6332c2b6"
import script from "./HistoryApprovalMappingList.vue?vue&type=script&lang=js"
export * from "./HistoryApprovalMappingList.vue?vue&type=script&lang=js"
script.render = render

export default script